export default __webpack_public_path__ + "static/media/Slide9.df1f29e2.jpg";